<div class="fieldset-wrapper" [ngClass]="
    (questions?.mandatory && isMandatoryUpfront) ||
    (questions?.mandatory && isFormSubmit && questions.isMandatoryInvalid)
      ? 'isMandatory'
      : ''
  ">
  <span *ngIf="(questions?.mandatory && isMandatoryUpfront) ||
    (questions?.mandatory && isFormSubmit && questions.isMandatoryInvalid)" class="screen-read-only">This Question is
    Required</span>
  <div *ngIf="questions?.group_no == 0 && questions?.QuestionImageAndMedia_1 != null" class="questionImageWrapper"
    [ngClass]="{ 'question-border': !isMobile }">
    <app-question-image-and-media [questionImageAndMedias]="questions?.QuestionImageAndMedia_1"
      [imageSize]="questions?.ImageSize" [isMobile]="isMobile">
    </app-question-image-and-media>
  </div>

  <fieldset [attr.aria-required]="isAriaRequired">
    <legend class="question-option-wrapper" [ngClass]="{
        'mobile-sub-question': isGrid,
        'question-border': questions?.QuestionImageAndMedia_1 == null && !isMobile && !isGrid
      }">
      <span *ngIf="isPreview && (questions.population_type == 2 || questions.population_type == 5)"
        class="hidden-question-tooltip-icon" appTooltip [dataContext]="''" [IsButtonPanel]="false"
        IsAnswerToolTip="true" IsHiddenQToolTip="true" tabindex="0">
      </span>
      <span *ngIf="isDisplayQno" class="question-no"><strong>{{ questions?.qno }}.</strong></span>
      <span *ngIf="questions?.piping && !isGrid" [ngClass]="{
          'question-text': questions?.isOverAllStyleApplied,
          'question-text-nb': !questions?.isOverAllStyleApplied,
          'mw-sub-question-text': isGrid,
          'no-Qno': !isDisplayQno
        }" id="lbltitle_C{{ questions?.UniqueNumber }}">
        <span [innerHTML]="questions?.pipingQuationTitle | headerFooterHtml"></span>
        <span *ngIf="questions?.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
          [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0">
        </span>
        <span class="imgPostPrepop" 
        *ngIf="isEditPostPop == true && (questions.population_type== 4 || questions.population_type == 5)"></span>
        <div *ngIf="
            questions?.hasMedia &&
            questions?.MediaText != null &&
            questions?.MediaText != '' &&
            questions?.group_no == 0
          " class="question-media-text">
          <span>[{{ questions?.MediaText }}]</span>
        </div>
        <div class="constraint-msg-wrapper">
          <div *ngIf="questions?.ansConstraint" [ngClass]="
              questions?.isAlertDanger
                ? 'q-title-txt inst-txt-style constraint-error-msg'
                : 'q-title-txt inst-txt-style'
            ">
            [{{ questions?.error_msg }}]
          </div>
        </div>
      </span>
      <span *ngIf="!questions?.piping || isGrid" [ngClass]="{
          'question-text': questions?.isOverAllStyleApplied,
          'question-text-nb': !questions?.isOverAllStyleApplied,
          'mw-sub-question-text': isGrid,
          'no-Qno': !isDisplayQno && !isGrid,
          'no-subQno': !isDisplaySubQno
        }" id="lbltitle_C{{ questions?.UniqueNumber }}">
        <span *ngIf="isDisplaySubQno; else NonDisplaySubQno" style="display: inline-block"
          [innerHTML]="questions?.subQnoinChar | headerFooterHtml"></span>
        <ng-template #NonDisplaySubQno>
          <span style="display: none"></span>
        </ng-template>
        <ng-container *ngIf="questions?.piping && isGrid; else NormalTitle">
          <span [innerHTML]="questions?.pipingQuationTitle | headerFooterHtml"></span>
        </ng-container>
        <ng-template #NormalTitle>
          <span [innerHTML]="questions?.qtitle | headerFooterHtml"></span>
        </ng-template>
        <span *ngIf="questions?.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
          [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0">
        </span>
        <span class="imgPostPrepop" 
        *ngIf="isEditPostPop == true && (questions.population_type== 4 || questions.population_type == 5)"></span>
        <div *ngIf="
            questions?.hasMedia &&
            questions?.MediaText != null &&
            questions?.MediaText != '' &&
            questions?.group_no == 0
          " class="question-media-text">
          <span>[{{ questions?.MediaText }}]</span>
        </div>
        <div class="constraint-msg-wrapper">
          <div *ngIf="questions?.ansConstraint" [ngClass]="
              questions?.isAlertDanger
                ? 'q-title-txt inst-txt-style constraint-error-msg'
                : 'q-title-txt inst-txt-style'
            ">
            [{{ questions?.error_msg }}]
          </div>
        </div>
      </span>
      <span *ngIf="isAriaRequired && (isMobile || isGrid)" class="screen-reader-only">This Question is Required</span>
    </legend>

    <div *ngIf="questions?.group_no == 0 && questions?.QuestionImageAndMedia_2 != null" class="questionImageWrapper">
      <app-question-image-and-media [questionImageAndMedias]="questions?.QuestionImageAndMedia_2"
        [imageSize]="questions?.ImageSize" [isMobile]="isMobile">
      </app-question-image-and-media>
    </div>

    <ng-container *ngIf="!isDisplayedPipeMessage; else answerPipeMessage">
      <div class="fieldset-wrapper-scroll-cont">
        <div class="div-scroll-btn"><span class="div-scroll-symbol"></span></div>
        <div class="fieldset-wrapper-scroll">
          <div style="display: table; width: 100%" class="answerParent">
            <div [ngClass]="
                questions?.qtype == 'ML' && answerLength > 4
                  ? 'ML_Main answer-option-wrapper'
                  : 'ML-inner answer-option-wrapper'
              ">
              <div [ngClass]="{
                  'answer-option-wrapper cb-box': true,
                  'ic-box': questions?.qsubtype != 0,
                  'ML-inner-scroll': questions?.qtype == 'ML' && answerLength > 4,
                  DispCol: questions?.DispAnsCol > 1
                }" [attr.data-ans-image]="answerImagesLength">
                <div *ngIf="questions?.qsubtype == 0; else ImageChoiceQuestion">
                  <div *ngIf="questions.population_type != 3; else PreReadPopulation">
                    <div *ngIf="
                        questions?.DispAnsCol > 1 || questions?.qtype == 'HR';
                        else SingleColumnCode
                      ">
                      <div class="">
                        <div *ngIf="!isMobile" id="div_Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_ID">
                          <div class="">
                            <table style="width: 100%" cellpadding="0" cellpadding="3" class="main-hrb-cont"
                              role="presentation">
                              <tr class="" *ngFor="let answer of answersArray">
                                <td *ngFor="let ans of answer; let i = index" [hidden]="ans?.isHide || ans?.isADLHide"
                                  [attr.colspan]="ans?.isOther ? questions?.DispAnsCol : ''" id="td_Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_{{
                                    ans.value_id
                                  }}" class="answer-option radio-hrb checkbox-hcb" [style.width]="columnWidth + '%'"
                                  [ngClass]="ans?.isQuotaDisable ? 'hrb-disabled' : ''">
                                  <table class="hrb-table" cellpadding="0" cellpadding="0" [ngClass]="
                                      HasSingleImageClass(i)
                                        ? 'singleImageAnswer'
                                        : HasMultiImageClass(i)
                                          ? 'multiImageAnswer'
                                          : ''
                                    " role="presentation">
                                    <!-- Normal Control-->
                                    <tr>
                                      <!-- Column For Images/Media -->
                                      <td>
                                        <div *ngIf="questions?.qtype != 'ML'">
                                          <app-answer-media [AnswerMedias]="ans?.AnswerMedias"></app-answer-media>
                                          <app-answer-images [AnswerImages]="ans?.AnswerImages"></app-answer-images>
                                        </div>
                                      </td>
                                      <td>
                                        <input type="checkbox" name="Q{{ questions?.qno }}_{{
                                            questions?.UniqueNumber
                                          }}_C_NAME" [attr.name]="
                                            'Q' +
                                            questions?.qno +
                                            '_' +
                                            questions?.UniqueNumber +
                                            '_C_NAME'
                                          " id="lbl_Q{{ questions?.qno }}_{{
                                            questions?.UniqueNumber
                                          }}_C_{{ ans.value_id }}_ID" value="{{ ans.value_id }}"
                                          [(ngModel)]="ans.ControlAns" [disabled]="ans?.isQuotaDisable"
                                          [attr.aria-label]="ans.value_text" />
                                        <label for="lbl_Q{{ questions?.qno }}_{{
                                            questions?.UniqueNumber
                                          }}_C_{{ ans.value_id }}_ID"
                                          [ngClass]="ans.ControlAns ? 'selectedAnsOpt' : ''"
                                          style="pointer-events: none">
                                          <span class="check-btn structure"></span>
                                          <span class="answer-text answer-text-hrb">
                                            <span [innerHTML]="ans.value_text | headerFooterHtml"></span>
                                            <span *ngIf="ans?.QuotaMessage" class="tooltip_icon" appTooltip
                                              [dataContext]="ans?.QuotaMessage" [IsButtonPanel]="false"
                                              [IsAnswerToolTip]="true" tabindex="0"></span>
                                          </span>
                                        </label>
                                      </td>
                                    </tr>
                                    <!-- Inline-QDL -->
                                    <tr *ngIf="ans?.Rule_id > 0">
                                      <td></td>
                                      <td>
                                        <label for="lbl_Q{{ questions?.qno }}_{{
                                            questions?.UniqueNumber
                                          }}_C_{{ ans.value_id }}_ID"
                                          [ngClass]="ans.ControlAns ? 'selectedAnsOpt' : ''">
                                          <div *ngIf="
                                              (ans?.Rule_id > 0 &&
                                                ans?.CQ_QID > 0 &&
                                                loadInlineQDL(ans?.Rule_id) != null) ||
                                              (ans?.Rule_id > 0 &&
                                                questions.DestinationQuestions != null &&
                                                loadDestinationQn(ans?.Rule_id) != null)
                                            " style="width: 100%">
                                            <ng-container *ngIf="
                                                ans?.Rule_id > 0 &&
                                                  ans?.CQ_QID > 0 &&
                                                  loadInlineQDL(ans?.Rule_id) != null;
                                                else DestinationQuestions1
                                              ">
                                              <div id="dv_{{
                                                  loadInlineQDL(ans?.Rule_id)?.UniqueNumber
                                                }}" class="question-data">
                                                <app-text-box [JsonData]="
                                                    GetQuestionsString(
                                                      loadInlineQDL(ans?.Rule_id),
                                                      i
                                                    )
                                                  " [isDisplayQno]="isDisplayQno"
                                                  [isMandatoryUpfront]="isMandatoryUpfront"
                                                  (ChangeAnswersData)="UpdateQuestionsData($event)">
                                                </app-text-box>
                                              </div>
                                            </ng-container>
                                            <ng-template #DestinationQuestions1>
                                              <div id="dv_{{
                                                  loadDestinationQn(ans?.Rule_id)?.UniqueNumber
                                                }}" class="question-data">
                                                <app-text-box [JsonData]="
                                                    GetQuestionsString(
                                                      loadDestinationQn(ans?.Rule_id),
                                                      i
                                                    )
                                                  " [isDisplayQno]="isDisplayQno"
                                                  [isMandatoryUpfront]="isMandatoryUpfront"
                                                  (ChangeAnswersData)="UpdateQuestionsData($event)">
                                                </app-text-box>
                                              </div>
                                            </ng-template>
                                          </div>
                                        </label>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                              <!-- IsOther Answer Row -->
                              <tr *ngIf="questions?.isOtherAnswer">
                                <td [attr.colspan]="questions?.DispAnsCol">
                                  <table [ngClass]="
                                      HasSingleImageClass(0)
                                        ? 'singleImageAnswer'
                                        : HasMultiImageClass(0)
                                          ? 'multiImageAnswer'
                                          : ''
                                    " style="width: 100%">
                                    <tr>
                                      <td>
                                        <div *ngIf="questions?.isOtherAnswer" class="other-textans check_other">
                                          <input type="text" [hidden]="!questions?.isOtherAnswer"
                                            [style.width]="questions?.twidth + '%'" [attr.name]="
                                              'Q' +
                                              questions?.qno +
                                              '_' +
                                              questions?.UniqueNumber +
                                              '_C_NAME'
                                            " class="ansopt-textbox" maxlength="3500"
                                            id="{{ questions?.UniqueNumber }}_txt_other"
                                            [(ngModel)]="questions.otherAnswer" [attr.aria-label]="questions.other_text"
                                            (blur)="onBlurMethod()" />
                                        </div>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                              <tr class="" *ngFor="let answer of answersArray1">
                                <td *ngFor="let ans of answer; let i = index" [hidden]="ans?.isHide || ans?.isADLHide"
                                  [attr.colspan]="ans?.isOther ? questions?.DispAnsCol : ''" id="td_Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_{{
                                    ans.value_id
                                  }}" class="answer-option radio-hrb checkbox-hcb" [style.width]="columnWidth + '%'"
                                  [ngClass]="ans?.isQuotaDisable ? 'hrb-disabled' : ''">
                                  <table class="hrb-table" cellpadding="0" cellpadding="0" [ngClass]="
                                      HasSingleImageClass(i)
                                        ? 'singleImageAnswer'
                                        : HasMultiImageClass(i)
                                          ? 'multiImageAnswer'
                                          : ''
                                    " role="presentation">
                                    <!-- Normal Control-->
                                    <tr>
                                      <!-- Column For Images/Media -->
                                      <td>
                                        <div *ngIf="questions?.qtype != 'ML'">
                                          <app-answer-media [AnswerMedias]="ans?.AnswerMedias"></app-answer-media>
                                          <app-answer-images [AnswerImages]="ans?.AnswerImages"></app-answer-images>
                                        </div>
                                      </td>
                                      <td>
                                        <input type="checkbox" name="Q{{ questions?.qno }}_{{
                                            questions?.UniqueNumber
                                          }}_C_NAME" [attr.name]="
                                            'Q' +
                                            questions?.qno +
                                            '_' +
                                            questions?.UniqueNumber +
                                            '_C_NAME'
                                          " id="lbl_Q{{ questions?.qno }}_{{
                                            questions?.UniqueNumber
                                          }}_C_{{ ans.value_id }}_ID" value="{{ ans.value_id }}"
                                          [(ngModel)]="ans.ControlAns" [disabled]="ans?.isQuotaDisable"
                                          [attr.aria-label]="ans.value_text" />
                                        <label for="lbl_Q{{ questions?.qno }}_{{
                                            questions?.UniqueNumber
                                          }}_C_{{ ans.value_id }}_ID"
                                          [ngClass]="ans.ControlAns ? 'selectedAnsOpt' : ''"
                                          style="pointer-events: none">
                                          <span class="check-btn structure"></span>
                                          <span class="answer-text answer-text-hrb">
                                            <span [innerHTML]="ans.value_text | headerFooterHtml"></span>
                                            <span *ngIf="ans?.QuotaMessage" class="tooltip_icon" appTooltip
                                              [dataContext]="ans?.QuotaMessage" [IsButtonPanel]="false"
                                              [IsAnswerToolTip]="true" tabindex="0"></span>
                                          </span>
                                        </label>
                                      </td>
                                    </tr>
                                    <!-- Inline-QDL -->
                                    <tr *ngIf="ans?.Rule_id > 0">
                                      <td></td>
                                      <td>
                                        <label for="lbl_Q{{ questions?.qno }}_{{
                                            questions?.UniqueNumber
                                          }}_C_{{ ans.value_id }}_ID"
                                          [ngClass]="ans.ControlAns ? 'selectedAnsOpt' : ''">
                                          <div *ngIf="
                                              (ans?.Rule_id > 0 &&
                                                ans?.CQ_QID > 0 &&
                                                loadInlineQDL(ans?.Rule_id) != null) ||
                                              (ans?.Rule_id > 0 &&
                                                questions.DestinationQuestions != null &&
                                                loadDestinationQn(ans?.Rule_id) != null)
                                            " style="width: 100%">
                                            <ng-container *ngIf="
                                                ans?.Rule_id > 0 &&
                                                  ans?.CQ_QID > 0 &&
                                                  loadInlineQDL(ans?.Rule_id) != null;
                                                else DestinationQuestions2
                                              ">
                                              <div id="dv_{{
                                                  loadInlineQDL(ans?.Rule_id)?.UniqueNumber
                                                }}" class="question-data">
                                                <app-text-box [JsonData]="
                                                    GetQuestionsString(
                                                      loadInlineQDL(ans?.Rule_id),
                                                      i
                                                    )
                                                  " [isDisplayQno]="isDisplayQno"
                                                  [isMandatoryUpfront]="isMandatoryUpfront"
                                                  (ChangeAnswersData)="UpdateQuestionsData($event)">
                                                </app-text-box>
                                              </div>
                                            </ng-container>
                                            <ng-template #DestinationQuestions2>
                                              <div id="dv_{{
                                                  loadDestinationQn(ans?.Rule_id)?.UniqueNumber
                                                }}" class="question-data">
                                                <app-text-box [JsonData]="
                                                    GetQuestionsString(
                                                      loadDestinationQn(ans?.Rule_id),
                                                      i
                                                    )
                                                  " [isDisplayQno]="isDisplayQno"
                                                  [isMandatoryUpfront]="isMandatoryUpfront"
                                                  (ChangeAnswersData)="UpdateQuestionsData($event)">
                                                </app-text-box>
                                              </div>
                                            </ng-template>
                                          </div>
                                        </label>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                        <div *ngIf="isMobile" id="div_Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_ID">
                          <div class="answer-option check" *ngFor="let answers of questions?.Answers; let i = index"
                            [ngClass]="getAnsImageMediaCSS(answers)" id="dv_Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_{{
                              answers.value_id
                            }}">
                            <div [hidden]="answers?.isHide || answers?.isADLHide">
                              <div *ngIf="questions?.qtype != 'ML'">
                                <app-answer-media [AnswerMedias]="answers?.AnswerMedias"></app-answer-media>
                                <app-answer-images [AnswerImages]="answers?.AnswerImages"></app-answer-images>
                              </div>
                              <input type="checkbox" name="Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_C_NAME"
                                [attr.name]="
                                  'Q' + questions?.qno + '_' + questions?.UniqueNumber + '_C_NAME'
                                " id="lbl_Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_C_{{
                                  answers?.value_id
                                }}_ID" value="{{ answers.value_id }}" [(ngModel)]="answers.ControlAns"
                                (change)="SelectedValue(answers, $event.target.checked)"
                                [disabled]="answers?.isQuotaDisable" [attr.aria-label]="answers.value_text" />

                              <label for="lbl_Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_C_{{
                                  answers?.value_id
                                }}_ID" [ngClass]="answers.ControlAns ? 'selectedAnsOpt' : ''">
                                <span class="check-btn structure"></span>
                                <span class="answer-text" [innerHTML]="answers.value_text | headerFooterHtml"></span>

                                <div *ngIf="
                                    (answers?.Rule_id > 0 &&
                                      answers?.CQ_QID > 0 &&
                                      loadInlineQDL(answers?.Rule_id) != null) ||
                                    (answers?.Rule_id > 0 &&
                                      questions.DestinationQuestions != null &&
                                      loadDestinationQn(answers?.Rule_id) != null)
                                  " style="width: 100%">
                                  <ng-container *ngIf="
                                      answers?.Rule_id > 0 &&
                                        answers?.CQ_QID > 0 &&
                                        loadInlineQDL(answers?.Rule_id) != null;
                                      else DestinationQuestions3
                                    ">
                                    <div id="dv_{{ loadInlineQDL(answers?.Rule_id)?.UniqueNumber }}"
                                      class="question-data">
                                      <app-text-box [JsonData]="
                                          GetQuestionsString(loadInlineQDL(answers?.Rule_id), i)
                                        " [isDisplayQno]="isDisplayQno" [isMandatoryUpfront]="isMandatoryUpfront"
                                        (ChangeAnswersData)="UpdateQuestionsData($event)">
                                      </app-text-box>
                                    </div>
                                  </ng-container>
                                  <ng-template #DestinationQuestions3>
                                    <div id="dv_{{
                                        loadDestinationQn(answers?.Rule_id)?.UniqueNumber
                                      }}" class="question-data">
                                      <app-text-box [JsonData]="
                                          GetQuestionsString(loadDestinationQn(answers?.Rule_id), i)
                                        " [isDisplayQno]="isDisplayQno" [isMandatoryUpfront]="isMandatoryUpfront"
                                        (ChangeAnswersData)="UpdateQuestionsData($event)">
                                      </app-text-box>
                                    </div>
                                  </ng-template>
                                </div>
                                  


                              <div *ngIf="answers?.Rule_id > 0 &&
                                questions.DestinationQuestions != null && loadDestinationQn(answers?.Rule_id) != null" style="width: 100%;">
                                <div id="dv_{{loadDestinationQn(answers?.Rule_id)?.UniqueNumber}}" class="question-data">
                                  <app-text-box [JsonData]="GetQuestionsString(loadDestinationQn(answers?.Rule_id), i)"
                                    [isDisplayQno]="isDisplayQno" [isMandatoryUpfront]="isMandatoryUpfront"
                                    (ChangeAnswersData)="UpdateQuestionsData($event)">
                                  </app-text-box>
                                </div>
                              </div> 
                              </label>
                              <div *ngIf="answers?.isOther" class="other-textans">
                                <input type="text" [hidden]="!questions?.isOtherAnswer"
                                  [style.width]="questions?.twidth + '%'" class="ansopt-textbox" maxlength="3500"
                                  id="{{ questions?.UniqueNumber }}_txt_other" [(ngModel)]="questions.otherAnswer"
                                  aria-label="textbox" (blur)="onBlurMethod()" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ng-template #SingleColumnCode>
                    <div class="answer-option check" *ngFor="let answers of questions?.Answers; let i = index"
                      [ngClass]="getAnsImageMediaCSS(answers)" id="dv_Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_{{
                        answers.value_id
                      }}">
                      <div [hidden]="answers?.isHide || answers?.isADLHide">
                        <span style="display: block" *ngIf="isMobile">
                          <div *ngIf="questions?.qtype != 'ML'">
                            <app-answer-media [AnswerMedias]="answers?.AnswerMedias"></app-answer-media>
                            <app-answer-images [AnswerImages]="answers?.AnswerImages"></app-answer-images>
                          </div>
                        </span>

                        <input type="checkbox" name="Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_C_NAME"
                          [attr.name]="
                            'Q' + questions?.qno + '_' + questions?.UniqueNumber + '_C_NAME'
                          " id="lbl_Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_C_{{
                            answers?.value_id
                          }}_ID" value="{{ answers.value_id }}" [(ngModel)]="answers.ControlAns"
                          (change)="SelectedValue(answers, $event.target.checked)"
                          [disabled]="answers?.isQuotaDisable || questions?.IsDisabled"
                          [attr.aria-label]="answers.value_text" />

                        <label for="lbl_Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_C_{{
                            answers?.value_id
                          }}_ID" [ngClass]="answers.ControlAns ? 'selectedAnsOpt' : ''">
                          <span style="
                              display: inline-block;
                              vertical-align: middle;
                              white-space: nowrap;
                            " *ngIf="!isMobile">
                            <div *ngIf="questions?.qtype != 'ML'">
                              <app-answer-media [AnswerMedias]="answers?.AnswerMedias"></app-answer-media>
                              <app-answer-images [AnswerImages]="answers?.AnswerImages"></app-answer-images>
                            </div>
                          </span>
                          <span class="check-btn structure"></span>
                          <span class="answer-text">
                            <span [innerHTML]="answers.value_text | headerFooterHtml"></span>
                            <span *ngIf="answers?.QuotaMessage" class="tooltip_icon" appTooltip
                              [dataContext]="answers?.QuotaMessage" [IsButtonPanel]="false" [IsAnswerToolTip]="true"
                              tabindex="0"></span>
                          </span>

                          <div *ngIf="
                              (answers?.Rule_id > 0 &&
                                answers?.CQ_QID > 0 &&
                                loadInlineQDL(answers?.Rule_id) != null) ||
                              (answers?.Rule_id > 0 &&
                                questions.DestinationQuestions != null &&
                                loadDestinationQn(answers?.Rule_id) != null)
                            " style="width: 100%">
                            <ng-container *ngIf="
                                answers?.Rule_id > 0 &&
                                  answers?.CQ_QID > 0 &&
                                  loadInlineQDL(answers?.Rule_id) != null;
                                else DestinationQuestions4
                              ">
                              <div *ngIf="
                                  isFormSubmit &&
                                  loadInlineQDL(answers?.Rule_id).AnswerText == null &&
                                  loadInlineQDL(answers?.Rule_id).isSoftRequired &&
                                  !pageIsSoftRequiredHandle &&
                                  nextButtonClickNo <= 1 &&
                                  !isCapchaManditorySkip
                                " class="inlineTB soft-req-msg">
                                {{ loadInlineQDL(answers?.Rule_id).SoftReqErrorMsg }}
                              </div>
                              <div *ngIf="
                                  isFormSubmit &&
                                  loadInlineQDL(answers?.Rule_id).mandatory &&
                                  loadInlineQDL(answers?.Rule_id).AnswerText == null &&
                                  !isCapchaManditorySkip
                                " class="inlineTB mndtry-txt-clr">
                                <div [innerHTML]="AsteriskMandatory | headerFooterHtml"></div>
                              </div>
                              <div id="dv_{{ loadInlineQDL(answers?.Rule_id)?.UniqueNumber }}" class="question-data 0"
                                [ngClass]="
                                  isFormSubmit &&
                                  loadInlineQDL(answers?.Rule_id).mandatory &&
                                  loadInlineQDL(answers?.Rule_id).AnswerText == null &&
                                  !isCapchaManditorySkip
                                    ? 'mandatory'
                                    : isFormSubmit &&
                                        loadInlineQDL(answers?.Rule_id).AnswerText == null &&
                                        loadInlineQDL(answers?.Rule_id).isSoftRequired &&
                                        !pageIsSoftRequiredHandle &&
                                        nextButtonClickNo <= 1 &&
                                        !isCapchaManditorySkip
                                      ? 'soft-req'
                                      : ''
                                ">
                                <app-text-box [JsonData]="
                                    GetQuestionsString(loadInlineQDL(answers?.Rule_id), i)
                                  " [isDisplayQno]="isDisplayQno" [isMandatoryUpfront]="isMandatoryUpfront"
                                  (ChangeAnswersData)="UpdateQuestionsData($event)">
                                </app-text-box>
                              </div>
                            </ng-container>
                            <ng-template #DestinationQuestions4>
                              <div id="dv_{{ loadDestinationQn(answers?.Rule_id)?.UniqueNumber }}"
                                class="question-data">
                                <app-text-box [JsonData]="
                                    GetQuestionsString(loadDestinationQn(answers?.Rule_id), i)
                                  " [isDisplayQno]="isDisplayQno" [isMandatoryUpfront]="isMandatoryUpfront"
                                  (ChangeAnswersData)="UpdateQuestionsData($event)">
                                </app-text-box>
                              </div>
                            </ng-template>
                          </div>
                        </label>
                        <div *ngIf="answers?.isOther" class="other-textans">
                          <input type="text" [hidden]="!questions?.isOtherAnswer"
                            [style.width]="questions?.twidth + '%'" class="ansopt-textbox" maxlength="3500"
                            id="{{ questions?.UniqueNumber }}_txt_other" [(ngModel)]="questions.otherAnswer"
                            (blur)="onBlurMethod()" aria-label="textbox" (blur)="onBlurMethod()" />
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </div>
                <ng-template #PreReadPopulation>
                  <!-- [ngClass]="(answers?.hasImage && answers?.AnswerImages.length == 1) ? 'single-ans-image' : (answers?.hasImage && answers?.AnswerImages.length == 2)? 'multi-ans-image': '' " -->
                  <div *ngIf="
                      (questions?.DispAnsCol > 1 || questions?.qtype == 'HR') && !isMobile;
                      else PreReadSingleColumnCode
                    ">
                    <div class="">
                      <div id="div_Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_ID">
                        <div class="">
                          <table style="width: 100%" cellpadding="0" cellpadding="3"
                            class="main-hrb-cont check-read-only" role="presentation">
                            <tr class="" *ngFor="let answer of answersArray">
                              <td *ngFor="let ans of answer; let i = index" [hidden]="ans?.isHide || ans?.isADLHide"
                                [attr.colspan]="ans?.isOther ? questions?.DispAnsCol : ''" id="td_Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_{{
                                  ans.value_id
                                }}" class="answer-option radio-hrb checkbox-hcb" [style.width]="columnWidth + '%'"
                                [ngClass]="ans?.isQuotaDisable ? 'hrb-disabled' : ''" style="pointer-events: none">
                                <div *ngIf="CheckInSelectedAnsertList(ans.value_id)">
                                  <table class="hrb-table" cellpadding="0" cellpadding="0" [ngClass]="
                                      HasSingleImageClass(i)
                                        ? 'singleImageAnswer'
                                        : HasMultiImageClass(i)
                                          ? 'multiImageAnswer'
                                          : ''
                                    " role="presentation">
                                    <!-- Normal Control-->
                                    <tr>
                                      <!-- Column For Images/Media -->
                                      <td>
                                        <div *ngIf="questions?.qtype != 'ML'">
                                          <app-answer-media [AnswerMedias]="ans?.AnswerMedias"></app-answer-media>
                                          <app-answer-images [AnswerImages]="ans?.AnswerImages"></app-answer-images>
                                        </div>
                                      </td>
                                      <td>
                                        <!-- <input type="checkbox" name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_C_NAME"
                                      [attr.name]="'Q'+questions?.qno+'_'+questions?.UniqueNumber+'_C_NAME'"
                                        id="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_C_{{ans.value_id}}_ID"
                                        value="{{ans.value_id}}" [(ngModel)]="ans.ControlAns"  style="pointer-events: none;"
                                        [disabled]="ans?.isQuotaDisable" [attr.aria-label]="ans.value_text"/> -->

                                        <!-- <input type="checkbox" name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_C_NAME"
                                      [attr.name]="'Q'+questions?.qno+'_'+questions?.UniqueNumber+'_C_NAME'"
                                        id="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_C_{{ans?.value_id}}_ID"
                                        value="{{ans.value_id}}" checked="true" style="pointer-events: none;"
                                        [attr.aria-label]="ans.value_text" /> -->

                                        <label for="lbl_Q{{ questions?.qno }}_{{
                                            questions?.UniqueNumber
                                          }}_C_{{ ans.value_id }}_ID"
                                          [ngClass]="ans.ControlAns ? 'selectedAnsOpt' : ''"
                                          style="pointer-events: none">
                                          <span class="answer-text answer-text-hrb">
                                            <span [innerHTML]="ans.value_text | headerFooterHtml"></span>
                                            <span *ngIf="ans?.QuotaMessage" class="tooltip_icon" appTooltip
                                              [dataContext]="ans?.QuotaMessage" [IsButtonPanel]="false"
                                              [IsAnswerToolTip]="true" tabindex="0"></span>
                                          </span>
                                        </label>
                                      </td>
                                    </tr>
                                    <!-- Inline-QDL -->
                                    <tr *ngIf="ans?.Rule_id > 0">
                                      <td></td>
                                      <td>
                                        <label for="lbl_Q{{ questions?.qno }}_{{
                                            questions?.UniqueNumber
                                          }}_C_{{ ans.value_id }}_ID"
                                          [ngClass]="ans.ControlAns ? 'selectedAnsOpt' : ''">
                                          <div *ngIf="
                                              (ans?.Rule_id > 0 &&
                                                ans?.CQ_QID > 0 &&
                                                loadInlineQDL(ans?.Rule_id) != null) ||
                                              (ans?.Rule_id > 0 &&
                                                questions.DestinationQuestions != null &&
                                                loadDestinationQn(ans?.Rule_id) != null)
                                            " style="width: 100%">
                                            <ng-container *ngIf="
                                                ans?.Rule_id > 0 &&
                                                  ans?.CQ_QID > 0 &&
                                                  loadInlineQDL(ans?.Rule_id) != null;
                                                else DestinationQuestions5
                                              ">
                                              <div id="dv_{{
                                                  loadInlineQDL(ans?.Rule_id)?.UniqueNumber
                                                }}" class="question-data">
                                                <app-text-box [JsonData]="
                                                    GetQuestionsString(
                                                      loadInlineQDL(ans?.Rule_id),
                                                      i
                                                    )
                                                  " [isDisplayQno]="isDisplayQno"
                                                  [isMandatoryUpfront]="isMandatoryUpfront"
                                                  (ChangeAnswersData)="UpdateQuestionsData($event)">
                                                </app-text-box>
                                              </div>
                                            </ng-container>
                                            <ng-template #DestinationQuestions5>
                                              <div id="dv_{{
                                                  loadDestinationQn(ans?.Rule_id)?.UniqueNumber
                                                }}" class="question-data">
                                                <app-text-box [JsonData]="
                                                    GetQuestionsString(
                                                      loadDestinationQn(ans?.Rule_id),
                                                      i
                                                    )
                                                  " [isDisplayQno]="isDisplayQno"
                                                  [isMandatoryUpfront]="isMandatoryUpfront"
                                                  (ChangeAnswersData)="UpdateQuestionsData($event)">
                                                </app-text-box>
                                              </div>
                                            </ng-template>
                                          </div>
                                        </label>
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </td>
                            </tr>
                            <!-- IsOther Answer Row -->
                            <tr *ngIf="questions?.isOtherAnswer">
                              <td [attr.colspan]="questions?.DispAnsCol">
                                <table [ngClass]="
                                    HasSingleImageClass(0)
                                      ? 'singleImageAnswer'
                                      : HasMultiImageClass(0)
                                        ? 'multiImageAnswer'
                                        : ''
                                  " style="width: 100%">
                                  <tr>
                                    <td>
                                      <div *ngIf="questions?.isOtherAnswer" class="other-textans">
                                        <div *ngIf="CheckInSelectedAnsertList(0)">
                                          <input type="text" [hidden]="!questions?.isOtherAnswer"
                                            [style.width]="questions?.twidth + '%'" [attr.name]="
                                              'Q' +
                                              questions?.qno +
                                              '_' +
                                              questions?.UniqueNumber +
                                              '_C_NAME'
                                            " class="ansopt-textbox" maxlength="3500"
                                            id="{{ questions?.UniqueNumber }}_txt_other"
                                            [(ngModel)]="questions.otherAnswer" [attr.aria-label]="questions.other_text"
                                            (blur)="onBlurMethod()" />
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                            <tr class="" *ngFor="let answer of answersArray1">
                              <td *ngFor="let ans of answer; let i = index" [hidden]="ans?.isHide || ans?.isADLHide"
                                [attr.colspan]="ans?.isOther ? questions?.DispAnsCol : ''" id="td_Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_{{
                                  ans.value_id
                                }}" class="answer-option radio-hrb checkbox-hcb" [style.width]="columnWidth + '%'"
                                [ngClass]="ans?.isQuotaDisable ? 'hrb-disabled' : ''" style="pointer-events: none">
                                <div *ngIf="CheckInSelectedAnsertList(ans.value_id)">
                                  <table class="hrb-table" cellpadding="0" cellpadding="0" [ngClass]="
                                      HasSingleImageClass(i)
                                        ? 'singleImageAnswer'
                                        : HasMultiImageClass(i)
                                          ? 'multiImageAnswer'
                                          : ''
                                    " role="presentation">
                                    <!-- Normal Control-->
                                    <tr>
                                      <!-- Column For Images/Media -->
                                      <td>
                                        <div *ngIf="questions?.qtype != 'ML'">
                                          <app-answer-media [AnswerMedias]="ans?.AnswerMedias"></app-answer-media>
                                          <app-answer-images [AnswerImages]="ans?.AnswerImages"></app-answer-images>
                                        </div>
                                      </td>
                                      <td>
                                    

                                        <input type="checkbox" name="Q{{ questions?.qno }}_{{
                                            questions?.UniqueNumber
                                          }}_C_NAME" [attr.name]="
                                            'Q' +
                                            questions?.qno +
                                            '_' +
                                            questions?.UniqueNumber +
                                            '_C_NAME'
                                          " id="lbl_Q{{ questions?.qno }}_{{
                                            questions?.UniqueNumber
                                          }}_C_{{ ans?.value_id }}_ID" value="{{ ans.value_id }}" checked="true"
                                          style="pointer-events: none" [attr.aria-label]="ans.value_text" />

                                        <label for="lbl_Q{{ questions?.qno }}_{{
                                            questions?.UniqueNumber
                                          }}_C_{{ ans.value_id }}_ID"
                                          [ngClass]="ans.ControlAns ? 'selectedAnsOpt' : ''"
                                          style="pointer-events: none">
                                          <span class="check-btn structure"></span>
                                          <span class="answer-text answer-text-hrb">
                                            <span [innerHTML]="ans.value_text | headerFooterHtml"></span>
                                            <span *ngIf="ans?.QuotaMessage" class="tooltip_icon" appTooltip
                                              [dataContext]="ans?.QuotaMessage" [IsButtonPanel]="false"
                                              [IsAnswerToolTip]="true" tabindex="0"></span>
                                          </span>
                                        </label>
                                      </td>
                                    </tr>
                                    <!-- Inline-QDL -->
                                    <tr *ngIf="ans?.Rule_id > 0">
                                      <td></td>
                                      <td>
                                        <label for="lbl_Q{{ questions?.qno }}_{{
                                            questions?.UniqueNumber
                                          }}_C_{{ ans.value_id }}_ID"
                                          [ngClass]="ans.ControlAns ? 'selectedAnsOpt' : ''">
                                          <div *ngIf="
                                              (ans?.Rule_id > 0 &&
                                                ans?.CQ_QID > 0 &&
                                                loadInlineQDL(ans?.Rule_id) != null) ||
                                              (ans?.Rule_id > 0 &&
                                                questions.DestinationQuestions != null &&
                                                loadDestinationQn(ans?.Rule_id) != null)
                                            " style="width: 100%">
                                            <ng-container *ngIf="
                                                ans?.Rule_id > 0 &&
                                                  ans?.CQ_QID > 0 &&
                                                  loadInlineQDL(ans?.Rule_id) != null;
                                                else DestinationQuestions6
                                              ">
                                              <div id="dv_{{
                                                  loadInlineQDL(ans?.Rule_id)?.UniqueNumber
                                                }}" class="question-data">
                                                <app-text-box [JsonData]="
                                                    GetQuestionsString(
                                                      loadInlineQDL(ans?.Rule_id),
                                                      i
                                                    )
                                                  " [isDisplayQno]="isDisplayQno"
                                                  [isMandatoryUpfront]="isMandatoryUpfront"
                                                  (ChangeAnswersData)="UpdateQuestionsData($event)">
                                                </app-text-box>
                                              </div>
                                            </ng-container>
                                            <ng-template #DestinationQuestions6>
                                              <div id="dv_{{
                                                  loadDestinationQn(ans?.Rule_id)?.UniqueNumber
                                                }}" class="question-data">
                                                <app-text-box [JsonData]="
                                                    GetQuestionsString(
                                                      loadDestinationQn(ans?.Rule_id),
                                                      i
                                                    )
                                                  " [isDisplayQno]="isDisplayQno"
                                                  [isMandatoryUpfront]="isMandatoryUpfront"
                                                  (ChangeAnswersData)="UpdateQuestionsData($event)">
                                                </app-text-box>
                                              </div>
                                            </ng-template>
                                          </div>
                                        </label>
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                      <!-- [ngClass]="(answers?.hasImage && answers?.AnswerImages.length == 1) ? 'single-ans-image' : (answers?.hasImage && answers?.AnswerImages.length == 2)? 'multi-ans-image': '' " -->
                    </div>
                  </div>
                  <ng-template #PreReadSingleColumnCode>
                    <div class="answer-option check check-read-only"
                      *ngFor="let answers of questions?.Answers; let i = index"
                      [ngClass]="getAnsImageMediaCSS(answers)">
                      <div [hidden]="answers?.isHide || answers?.isADLHide">
                        <div *ngIf="CheckInSelectedAnsertList(answers.value_id)">
                          <label for="lbl_Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_C_{{
                              answers?.value_id
                            }}_ID" [ngClass]="answers.ControlAns ? 'selectedAnsOpt' : ''" style="pointer-events: none">
                            <div *ngIf="questions?.qtype != 'ML'">
                              <app-answer-media [AnswerMedias]="answers?.AnswerMedias"></app-answer-media>
                              <app-answer-images [AnswerImages]="answers?.AnswerImages"></app-answer-images>
                            </div>
                            <span class="answer-text" [innerHTML]="answers.value_text | headerFooterHtml"></span>

                            <div *ngIf="
                                (answers?.Rule_id > 0 &&
                                  answers?.CQ_QID > 0 &&
                                  loadInlineQDL(answers?.Rule_id) != null) ||
                                (answers?.Rule_id > 0 &&
                                  questions.DestinationQuestions != null &&
                                  loadDestinationQn(answers?.Rule_id) != null)
                              " style="width: 100%">
                              <ng-container *ngIf="
                                  answers?.Rule_id > 0 &&
                                    answers?.CQ_QID > 0 &&
                                    loadInlineQDL(answers?.Rule_id) != null;
                                  else DestinationQuestions7
                                ">
                                <div id="dv_{{ loadInlineQDL(answers?.Rule_id)?.UniqueNumber }}" class="question-data">
                                  <app-text-box [JsonData]="
                                      GetQuestionsString(loadInlineQDL(answers?.Rule_id), i)
                                    " [isDisplayQno]="isDisplayQno" [isMandatoryUpfront]="isMandatoryUpfront"
                                    (ChangeAnswersData)="UpdateQuestionsData($event)">
                                  </app-text-box>
                                </div>
                              </ng-container>
                              <ng-template #DestinationQuestions7>
                                <div id="dv_{{ loadDestinationQn(answers?.Rule_id)?.UniqueNumber }}"
                                  class="question-data">
                                  <app-text-box [JsonData]="
                                      GetQuestionsString(loadDestinationQn(answers?.Rule_id), i)
                                    " [isDisplayQno]="isDisplayQno" [isMandatoryUpfront]="isMandatoryUpfront"
                                    (ChangeAnswersData)="UpdateQuestionsData($event)">
                                  </app-text-box>
                                </div>
                              </ng-template>
                            </div>
                          </label>
                          <div *ngIf="answers?.isOther" class="other-textans">
                            <input type="text" [hidden]="!questions?.isOtherAnswer"
                              [style.width]="questions?.twidth + '%'" class="ansopt-textbox" maxlength="3500"
                              id="{{ questions?.UniqueNumber }}_txt_other" [(ngModel)]="questions.otherAnswer"
                              aria-label="textbox" (blur)="onBlurMethod()" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </ng-template>

                <ng-container *ngIf="
                    isNewParticipation &&
                    (surveyFormat == 1 || surveyFormat == 2) &&
                    (questions?.qtype != 'ML' || answerLength <= 4)
                  ">
                  <div class="ques-response-btn-div">
                    
                    <button *ngIf="showNewParticipationButton && isAnsChange" type="button" class="ques-response-btn"
                      (keyup.Space)="gotoNextQuestionKeyboard(questions, $event)"
                      (click)="gotoNextQuestion(questions, $event.target)">
                      {{ newParticipationBtnText }}
                    </button>
                  </div>
                </ng-container>
              </div>

              <ng-container *ngIf="
                  isNewParticipation &&
                  (surveyFormat == 1 || surveyFormat == 2) &&
                  questions?.qtype == 'ML' &&
                  answerLength > 4
                ">
                <div class="ques-response-btn-div">
                    
                  <button *ngIf="showNewParticipationButton && isAnsChange" type="button" class="ques-response-btn"
                    (keyup.Space)="gotoNextQuestionKeyboard(questions, $event)"
                    (click)="gotoNextQuestion(questions, $event.target)">
                    {{ newParticipationBtnText }}
                  </button>
                </div>
              </ng-container>
              <ng-template #ImageChoiceQuestion>
                <div class="image-choice-wrapper clearfix"
                  id="div_Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_ID">
                  <div class="ic-image-holder fl" *ngFor="let answers of questions?.Answers" [ngClass]="{
                      showReportValue: questions?.isShowReportingVal,
                      alignVertical: questions?.DispAnsFormat == 1
                    }" [ngStyle]="{ 'pointer-events': questions?.population_type == 3 ? 'none' : '' }"
                    [hidden]="answers?.isHide || answers?.isADLHide">
                    <input type="checkbox" name="Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_C_NAME"
                      [attr.name]="'Q' + questions?.qno + '_' + questions?.UniqueNumber + '_C_NAME'" id="lbl_Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_C_{{
                        answers?.value_id
                      }}_ID" value="{{ answers.value_text }}" [(ngModel)]="answers.ControlAns" (change)="
                        !answers.isQuotaDisable ? SelectedValue(answers, $event.target.checked) : ''
                      " [disabled]="answers?.isQuotaDisable" [attr.aria-label]="answers.value_text" />
                    <label *ngFor="let image of answers.AnswerImages" class="ic-label"
                      style="margin: 0; color: transparent; user-select: none" [ngClass]="[
                        image?.imageSize == 1 ? 'small' : '',
                        image?.imageSize == 2 ? 'medium' : '',
                        image?.imageSize == 3 ? 'large' : '',
                        answers.isQuotaDisable ? 'quotaGrayedOut' : ''
                      ]" [ngStyle]="{
                        'background-image': image.imageName
                          ? 'url(' + image.imagePath + image.imageName + ')'
                          : 'url(' + image.imageURL + ')'
                      }" for="lbl_Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_C_{{
                        answers?.value_id
                      }}_ID">
                      <div class="selectImage">
                        <span class="ic-tick"></span>
                      </div>
                      {{ answers.value_text }}
                    </label>
                    <span *ngIf="answers?.QuotaMessage" class="tooltip_icon" appTooltip
                      [dataContext]="answers?.QuotaMessage" [IsButtonPanel]="false" [IsAnswerToolTip]="true"
                      tabindex="0"></span>
                    <div *ngIf="questions?.isShowReportingVal" class="ic-report-value"
                      [innerHTML]="answers.value_text | headerFooterHtml"
                      (click)="!answers.isQuotaDisable ? checkboxSelection(answers) : ''"
                      title="{{ answers.value_text }}"></div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #answerPipeMessage>
      <span [innerHTML]="getAnswerPipeMessage() | headerFooterHtml" class="hidden-message"></span>
    </ng-template>
  </fieldset>
</div>